import skillApi from '../../api/skill'

// initial state
const state = {
  globalSkills: []
}

const getters = {
}

const actions = {
  getAllGlobal ({ commit }) {
    return new Promise((resolve) => {
      skillApi.getAll(skills => {
        commit('setGlobalSkills', skills)
        resolve()
      })
    })
  },
  create ({ dispatch, commit }, params) {
    return new Promise((resolve, reject) => {
      skillApi.create(params, skill => {
        commit('addToGlobalSkills', skill)
        resolve()
      },
      error => {
        console.log('Something broke at the API');
        reject()
      })
    })
  },

  destroy ({ dispatch, commit }, id) {
    return new Promise((resolve, reject) => {
      skillApi.destroy(id, destroyedSkill => {
        commit('removeFromGlobalSkills', destroyedSkill.id)
        resolve()
      },
      error => {
        console.log('Something broke at the API');
        reject()
      })
    })
  },
}

const mutations = {
  setGlobalSkills (state, skills) {
    state.globalSkills = skills
  },
  addToGlobalSkills (state, skill) {
    state.globalSkills = state.globalSkills.concat(skill)
  },
  removeFromGlobalSkills (state, id) {
    state.globalSkills = state.globalSkills.filter(skill => skill.id != id)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
